import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://www.mediolanumconsulting.com";

export default function Seo({ title, description, noindex = false }) {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname}`;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${SITE}/og-image.png`} />
      {description && <meta property="og:description" content={description} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:image" content={`${SITE}/og-image.png`} />
      {description && <meta name="twitter:description" content={description} />}
    </Helmet>
  );
}
